import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WHATSAPP_NUMBER = '919196054906';
const DEFAULT_MESSAGE = "Hi ZustandTech, I'd like to know more about your services.";

const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Chat with ZustandTech on WhatsApp"
    >
      <span className="whatsapp-fab-ping"></span>
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppButton;
